import {
  Children,
  type HTMLAttributes,
  type ReactElement,
  cloneElement,
  forwardRef,
  useRef,
} from "react";
import { useVirtualizer } from "@tanstack/react-virtual";

const ITEM_HEIGHT = 40.5;

export const virtualizedList = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ children, ...props }, ref) => {
    const items = Children.toArray(children);
    const parentRef = useRef<HTMLDivElement>(null);
    const rowVirtualizer = useVirtualizer({
      count: items.length,
      estimateSize: () => ITEM_HEIGHT,
      getScrollElement: () => parentRef.current,
    });
    const vitems = rowVirtualizer.getVirtualItems().map(virtualItem => {
      const item = items[virtualItem.index] as ReactElement<HTMLLIElement>;
      return cloneElement(item, {
        style: {
          ...item.props.style,
          position: "absolute",
          top: "0px",
          left: "0px",
          height: `${virtualItem.size}px`,
          width: "100%",
          transform: `translateY(${virtualItem.start}px)`,
        },
      });
    });

    return (
      <div ref={ref} {...props} style={{ padding: "0px" }}>
        <div
          ref={parentRef}
          style={{
            height: parentRef.current?.parentElement?.getBoundingClientRect().height,
            overflowY: "auto",
          }}
        >
          <ul
            style={{
              height: `${rowVirtualizer.getTotalSize()}px`,
              position: "relative",
            }}
          >
            {vitems}
          </ul>
        </div>
      </div>
    );
  }
);
